import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt-BR', 'es'],
    load: 'currentOnly', // Don't try to load pt when pt-BR is requested
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      // Cache-bust per build so newly-deployed translation keys appear
      // immediately. The locale JSONs are unhashed and served with max-age, and
      // the service worker caches them (StaleWhileRevalidate) — without a
      // version token a fresh deploy keeps serving the old file, so new keys
      // render as the raw key string (e.g. "login.errors.invalidCredentials")
      // until the cache expires. __GIT_HASH__ changes every deploy.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__GIT_HASH__ || __APP_VERSION__}`,
    },

    defaultNS: 'common',
    // Pages mounted with useTranslation('settings') etc. still routinely reach
    // for shared keys like `notifications.*` or `common.error`. Without a
    // fallback they render the raw key string. Falling back to `common` keeps
    // shared keys working from any namespace without forcing every call site
    // to remember the `common:` prefix.
    fallbackNS: 'common',
    ns: ['common', 'auth', 'analysis', 'pricing', 'settings', 'journal', 'admin', 'help'],

    detection: {
      order: ['localStorage', 'querystring', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false, // Prevent Suspense issues
    },

    // Use v3 compatibility to support _plural suffix used throughout locale files
    compatibilityJSON: 'v3',
  });

export default i18n;
